var b64toBlob = require("b64-to-blob");

module.exports = function dataURLToBlob(dataURL) {
    var validationRegExp = /^\s*data:image\/[a-zA-Z0-9\-\+\.]+;base64,[a-zA-Z0-9\+\/\=]+\s*$/,
        extractionRegExp = /^\s*data:([a-zA-Z0-9]+\/[a-zA-Z0-9\-\+\.]+);base64,([a-zA-Z0-9\+\/\=]+\s*)/,
        matches,
        mimeType,
        base64String,
        blob;

    // Data URL with image required
    if (!validationRegExp.test(dataURL)) {
        return null;
    }

    // Extract mimeType and base64String
    matches      = dataURL.match(extractionRegExp);
    mimeType     = matches && matches[1] ? matches[1] : null;
    base64String = matches && matches[2] ? matches[2] : null;

    // Create Blob
    blob = b64toBlob(base64String, mimeType);

    return blob instanceof Blob ? blob : null;
};
